import { escapeRegExp as escapeRegExp$1 } from "../../string/escapeRegExp.mjs";
import { toString } from "../util/toString.mjs";
//#region src/compat/string/escapeRegExp.ts
/**
* Escapes the RegExp special characters "^", "$", "\\", ".", "*", "+", "?", "(", ")", "[", "]", "{", "}", and "|" in `str`.
*
* @param {string} str The string to escape.
* @returns {string} Returns the escaped string.
*
* @example
* import { escapeRegExp } from 'es-toolkit/string';
*
* escapeRegExp('[es-toolkit](https://es-toolkit.dev/)'); // returns '\[es-toolkit\]\(https://es-toolkit\.dev/\)'
*/
function escapeRegExp(str) {
	return escapeRegExp$1(toString(str));
}
//#endregion
export { escapeRegExp };
